import React from 'react'
import { createStyles, makeStyles, Typography, Box, Modal, Slide } from '@material-ui/core'
import { Colors, Pallete } from '../../atoms/Colors'
import { Button } from '../../atoms/Button'

interface ModalAlertProps {
  message: string
  open: boolean
  onClose: () => void
}

const useStyles = makeStyles(() =>
  createStyles({
    message: {
      padding: '24px'
    },
    modal: {
      display: 'flex',
      alignItems: 'center',
      justifyContent: 'center'
    }
  })
)

export const ModalAlert = ({ message, open, onClose }: ModalAlertProps) => {
  const classes = useStyles()

  return (
    <Modal open={open} onClose={onClose} className={classes.modal}>
      <Slide in={open} direction="up">
        <Box
          display="flex"
          flexDirection="column"
          justifyContent="space-between"
          minWidth="580px"
          minHeight="138px"
          position="relative"
          bgcolor={Pallete.functional.background.default}
          borderRadius="10px"
          border={`1px solid ${Colors.background.gray}`}
        >
          <Typography className={classes.message} variant="body2">
            {message}
          </Typography>
          <Box
            display="flex"
            alignItems="center"
            justifyContent="end"
            height="58px"
            bgcolor={Colors.background.lightGray}
            borderRadius="0 0 10px 10px"
            boxShadow={`inset 0px 1px 0px ${Colors.background.gray}`}
          >
            <Box mr="24px">
              <Button kind="neutral" variant="outlined" title="閉じる" onClick={onClose} />
            </Box>
          </Box>
        </Box>
      </Slide>
    </Modal>
  )
}
